import {
    PlatformNavbar,
    PlatformNavbarMode
} from "@flexinet/ui-components";
import {getMenuItems} from "../data/menus.tsx";
import {useAllowedActions} from '../../../hooks/useAllowedActions.ts';
import {isRbacAction} from '../../../config/rbac/actions.ts';

export const PortalNavbar = (
    {
        mode,
        changeMode
    }: {
        mode: PlatformNavbarMode,
        changeMode: (mode: PlatformNavbarMode) => void
    }) => {

    const {allowedActions} = useAllowedActions()

    const items = getMenuItems()

    const menuItems = items.filter((item) => {
        return isRbacAction(item.rbac) && allowedActions.includes(item.rbac)
    });


    return <PlatformNavbar
        appTitle={"Marketplace Console"}
        menuItems={menuItems}
        mode={mode}
        changeMode={changeMode}

    />

};